import { ContentContainer } from "./Layout.style";
import {MainContainer} from "./Layout.style"
import React, {useEffect} from "react";
import { Outlet } from "react-router-dom";
import useAppUrl from "../../../hooks/useAppUrl";

const FrontpageLayout = () => {
  const { appPath, setAppPath, appName, setAppName } = useAppUrl();

  useEffect(() => {
    setAppName("Насловна страна");
    setAppPath("/frontpage");
  }, []);
  return (
    <>
      
        <ContentContainer>
          <Outlet />
        </ContentContainer>
      
    </>
  );
};

export default FrontpageLayout;
